export const showToast = (vueInstance, message, title, variant = 'primary', autoHideDelay = 2000) => {
  vueInstance.$bvToast.toast(message, {
    title,
    variant,
    pauseOnHover: true,
    solid: true,
    autoHideDelay,
  });
};
